import { Button } from '@workspace/ui/components/Button';
import { Typography } from '@workspace/ui/components/Typography';
import { cn } from '@workspace/ui/lib/utils';
import { observer } from 'mobx-react-lite';
import type React from 'react';
import { type MouseEventHandler, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { company } from '~/company/Company';

interface EmptyWithFiltersProps
  extends Omit<React.ComponentPropsWithoutRef<'div'>, 'children' | 'onReset'> {
  onReset: MouseEventHandler;
}

export const EmptyWithFilters = observer<EmptyWithFiltersProps>(
  ({ onReset, className, ...props }) => {
    const { t } = useTranslation();

    const [canShow, setCanShow] = useState(false);

    useEffect(() => {
      const timer = setTimeout(() => setCanShow(true), 500);
      return () => clearTimeout(timer);
    });

    return canShow ? (
      <div {...props} className={cn('flex flex-col items-center', className)}>
        {company.images.search.empty && (
          <img
            src={company.images.search.empty}
            alt=""
            className="m-auto size-50"
          />
        )}
        <Typography.Header200Light className="mt-2! text-center">
          {t('nothingFound')}
        </Typography.Header200Light>
        <Typography.Text200Medium className="mt-2! text-center">
          {t('tryToReset')}
        </Typography.Text200Medium>
        <Button size="lg" onClick={onReset} className="mt-6">
          {t('resetAll')}
        </Button>
      </div>
    ) : null;
  },
);
